import { ReactElement, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Redirect({ to }: { to: string }): ReactElement | null {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(to)?.catch(console.error);
  }, [navigate, to]);

  return null;
}
